import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const sendPreInspectionEmail = async (formData) => {
  try {
    const blob = await createFormPdf({
      title: 'PRE INSPECTION FORM',
      ref: 'Ref: PVS-PIF-001 | Version: 1.0',
    }, (pdf) => {
      pdf.section('INSPECTOR INFORMATION');
      pdf.field('Inspector Name', formData.inspectorName);
      pdf.field('Date', formData.date);

      pdf.section('VESSEL INFORMATION');
      pdf.field('Serial Number', formData.serialNumber);
      pdf.field('Manufacturer', formData.manufacturer);
      pdf.field('Water Capacity', formData.waterCapacity);
      pdf.field('Vessel Owner', formData.vesselOwner);
      pdf.field('Type Of Inspection Due', formData.typeOfInspectionDue);

      pdf.section('INSPECTION CHECKLIST');
      pdf.check('Vessel Present In Inventory', formData.vesselPresentInInventory);
      pdf.check('Vessel Free from Excessive Corrosion', formData.vesselFreeFromCorrosion);
      pdf.check('Vessel Does Not Contain Manyways', formData.vesselDoesNotContainManyways);
      pdf.check('Vessel Structure Intact', formData.vesselStructureIntact);
      pdf.check('Vessel Data Plate Present and Legible', formData.vesselDataPlatePresent);
      pdf.check('No Evidence of Contamination', formData.noEvidenceOfContamination);
      pdf.check('Lifting Lugs Present and No Evidence of Defects', formData.liftingLugsPresent);
      pdf.check('Vessel Free from Dents and Bulges', formData.vesselFreeFromDents);
      pdf.check('Vessel Inspection Date Due', formData.vesselInspectionDateDue);

      if (formData.additionalComments) {
        pdf.section('INSPECTOR ADDITIONAL COMMENTS');
        pdf.longText('', formData.additionalComments);
      }
    });

    const formDataToSend = new FormData();
    formDataToSend.append('file', blob, `Pre_Inspection_${formData.serialNumber}_${Date.now()}.pdf`);
    formDataToSend.append('inspectorName', formData.inspectorName);
    formDataToSend.append('date', formData.date);
    formDataToSend.append('serialNumber', formData.serialNumber);
    formDataToSend.append('manufacturer', formData.manufacturer);
    formDataToSend.append('waterCapacity', formData.waterCapacity);
    formDataToSend.append('vesselOwner', formData.vesselOwner);
    formDataToSend.append('typeOfInspectionDue', formData.typeOfInspectionDue);
    formDataToSend.append('formType', 'pre-inspection');

    const response = await fetch(`${API_URL}/send-pre-inspection-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendPreInspectionEmail:', error);
    throw error;
  }
};

export default sendPreInspectionEmail;
